import React, { useState } from "react";
import styled from "styled-components";
import { Button, Icon } from "../../atoms";
import { ModalView } from "../Modal/Modal";

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 52px;
  .caption {
    color: ${(theme) => theme.theme.Light2};
    font-size: 14px;
    font-weight: normal;
    margin: 0 auto;
  }
`;
const WarningWrapper = styled.div`
  height: 100%;
  display: flex;
  padding: 15px;
  flex-flow: row wrap;
  .help-header {
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: space-around;
    span {
      color: ${(theme) => theme.theme.Light1};
      font-weight: 500;
      font-size: 14px;
    }
  }
  .help-body {
    display: flex;
    align-items: center;
    p {
      margin: 0;
      text-align: right;
      color: ${(theme) => theme.theme.Light1};
      font-weight: normal;
      font-size: 12px;
    }
  }
  .help-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
`;
export const EasyTradeHeader: React.FC = () => {
  const [showHelp, setShowHelp] = useState(false);
  const openHelpModal = () => {
    setShowHelp(true);
  };
  return (
    <WrapperDiv className="container">
      <div onClick={openHelpModal}>
        <Icon name={"info"} width={"16px"} height={"16px"} />
      </div>
      <span className="caption">سفارش آسان</span>
      <ModalView
        height="184px"
        show={showHelp}
        handleClose={() => setShowHelp(false)}
      >
        <WarningWrapper>
          <div className="help-header">
            <Icon name="carbonwarning" width="24px" height="25px" />
            <span>خرید‌آسان، خریدی سریع و بدون دردسر</span>
          </div>
          <div className="help-body">
            <p>
              قیمت واحد، تقریبی بوده و مقدار دریافتی با مقدار نشان داده شده
              اندکی تفاوت دارد.
            </p>
          </div>
          <div className="help-footer">
            <Button
              id="130"
              customStyle="font-size: 12px;box-shadow:none;
                            line-height:8px;
                            height: 28px;
                            "
              text={"اطلاعات بیشتر"}
              color={"white"}
              backgroundColor={"Light5"}
              onClick={() => setShowHelp(false)}
            />
            <Button
              id="131"
              customStyle="border-radius: 16px;padding: 8px 32px;
                            line-height:13px;
                            height: 28px;font-size: 12px;"
              primary={true}
              text={"فهمیدم"}
              color={"white"}
              backgroundColor={"blue"}
              onClick={() => setShowHelp(false)}
            />
          </div>
        </WarningWrapper>
      </ModalView>
    </WrapperDiv>
  );
};
